/**
 * Decorative divider between major homepage sections. Upgrades the live
 * site's plain `<hr class="divider">` (index.html — a static `.5px` border
 * line, see INVENTORY.md) into a thin gradient line with a small comet of
 * warm light that continuously slides back and forth along it. Fire/amber
 * only, per the site's cyan-reservation rule (see app/handoff.md §7) — this
 * is a decorative "selected"-adjacent highlight, not a bundle-savings
 * number, so it stays in the fire/amber family like everything else.
 *
 * Pure CSS animation (no JS, no scroll listener) so it costs nothing and
 * respects prefers-reduced-motion automatically via the global rule in
 * index.css that zeroes all animation-durations for that preference.
 */
export function SectionDivider() {
  return (
    <div aria-hidden="true" className="relative mx-auto h-px w-full max-w-container px-6 md:px-margin-desktop">
      <div className="relative h-px w-full overflow-hidden bg-white/10">
        <div className="section-divider-comet absolute inset-y-0 left-0 w-1/3" />
      </div>
    </div>
  )
}
